// store/dashboard/shared/index.js
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// Tek kaynak: panel + layout + ortak listeler
const state = () => ({
  panelDetails: {},        // { [panelId]: { layout, widgets, raw } }
  dashboardLayouts: {},    // { [pageType]: layout }
  availableWidgets: {},    // { [pageType]: [] }
  // Legacy field kept for compatibility; use activePanel instead
  activePanelIds: {},      // { [pageType]: panelId }
  // Actual state used by getters/mutations
  panels: {},              // { [pageType]: Panel[] }
  activePanel: {},         // { [pageType]: panelId }
  pageWidgets: {},         // { [pageType]: Widget[] }
  loading: {},             // { key: boolean }
  errors: {                // error buckets
    layout: null,
    widgets: null,
    save: null
  },
  queues: [],
  accounts: []
})

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}

// İsteğe bağlı: helper ve sabitleri dışarı da aç
export * from './helpers'
